"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = registerPlayer;
var _registryHelpers = _interopRequireDefault(require("./utils/registryHelpers"));
var _registry = _interopRequireDefault(require("./utils/registry"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function registerPlayer(player) {
  // Get player type (theo), and it's register (requested, ready, players)
  var type = player.name.toLowerCase();
  var playerTypeRegistry = _registry["default"][type];

  // Does the ID already exist? Blow up.
  if (playerTypeRegistry.players[player.id]) {
    throw new Error("Player with id[".concat(player.id, "] already exists"));
  }

  // Add player to register
  playerTypeRegistry.players[player.id] = player;
  if (!playerTypeRegistry.requested) {
    playerTypeRegistry.requested = true;

    // Call player type request method (scripts etc)
    _registryHelpers["default"]["".concat(type, "Init")](_registry["default"]);
  } else if (playerTypeRegistry.ready) {
    // Construct the player as everything is ready
    player._onPlayerLoaded();
  }
}